export default __webpack_public_path__ + "static/media/fragrant-herbs.6b6c584d.webp";